import req from "../http";

const file = {
  // 依檔案群組Guid 取得檔案清單
  getFileDetails(params, fileGroupGuid) {
    return req("get", `/FileUpload/GetFileDetails/${fileGroupGuid}`, params);
  },

  // 依檔案群組Guid 取得大頭照 base64 與 fileGuid
  getResumeHeadPhoto(params) {
    return req("get", "/FileUpload/GetResumeHeadPhoto", params);
  },

  // 下載 IDL 履歷 PDF
  downloadIDLResumePDF(resumeId) {
    return req("get", `/ResumeModule/DownloadPDF/IDL/${resumeId}`, null, { responseType: "blob" });
  },

  // 下載 履歷範例
  downloadResumeTemplate() {
    return req("get", "/ResumeModule/Resume/TemplateDownload", null, { responseType: "blob" });
  },

  // 下載 DL 履歷 PDF
  downloadDLResumePDF(resumeId) {
    return req("get", `/ResumeModule/DownloadPDF/DL/${resumeId}`, null, { responseType: "blob" });
  },

  // 下載 簡歷 PDF
  downloadSummaryPDF(resumeId) {
    return req("get", `/ResumeModule/DownloadPDF/Summary/${resumeId}`, null, { responseType: "blob" });
  },

  // 上傳 檔案
  uploadFile(params) {
    return req("post", "/FileUpload/UploadFile", params, { headers: { "Content-Type": "multipart/form-data" } });
  },

  // 下載 檔案
  downloadFile(fileGuid) {
    return req("get", `/FileUpload/DownloadFile/${fileGuid}`, null, { responseType: "blob" });
  },
  
  // 下載 檔案 by 檔案群組
  downloadFileGroupFirstFile(fileGroupGuid) {
    return req("get", `/FileUpload/DownloadFileGroupFirstFile/${fileGroupGuid}`, null, { responseType: "blob" });
  },
  
  // 檔案 更新為待刪除狀態
  removeFile(fileGuid) {
    return req("put", `/FileUpload/RemoveFile/${fileGuid}`);
  },
};

export default file;